import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FormatNumberDecimalPipe'
})
export class FormatNumberDecimalPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    // Formatar o número com duas casas decimais
    const formattedValue = value.toFixed(2);

    // Separar a parte inteira e a parte decimal
    const [integerPart] = formattedValue.split('.');

    // Adicionar pontos aos milhares na parte inteira
    const integerWithDots = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return integerWithDots;
  }
}
